import { TColumn } from '@sketchnote/table';
import cloneDeep from 'lodash/cloneDeep';
import { useMemo } from 'react';

import { FreezePaneProps } from './freeze-pane';

export const useFreezeApply = ({
  freezeValue,
  columns,
}: {
  freezeValue: FreezePaneProps['freezeValue'];
  columns: TColumn[];
}) => {
  const changedColumns = useMemo(() => {
    if (freezeValue !== undefined && freezeValue > 0) {
      const clonedColumns = cloneDeep(columns);
      for (let i = 0; i <= freezeValue - 1; i++) {
        clonedColumns[i] = {
          ...clonedColumns[i],
          frozen: true,
        };
      }
      return clonedColumns;
    }

    return columns;
  }, [columns, freezeValue]);

  return changedColumns;
};
